module.exports = __webpack_public_path__ + "static/Icons_reversemortgage_Small_Active-b405e194eeaf4886698fe849f6fb6b08.png";